/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnnuityAccountErrorsRouteImport } from './routes/annuity-account-errors'
import { Route as AutoForceOutsRouteImport } from './routes/auto-force-outs'
import { Route as CampaignsRouteImport } from './routes/campaigns'
import { Route as ConnectivityRouteImport } from './routes/connectivity'
import { Route as DbInsightsRouteImport } from './routes/db-insights'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ParticipantTransactionsRouteImport } from './routes/participant-transactions'
import { Route as QueuesRouteImport } from './routes/queues'
import { Route as RelationshipHealthRouteImport } from './routes/relationship-health'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SsoErrorsRouteImport } from './routes/sso-errors'
import { Route as ActivityMonitorIndexRouteImport } from './routes/activity-monitor/index'
import { Route as ApiKeysIndexRouteImport } from './routes/api-keys/index'
import { Route as AutoForceOutsIndexRouteImport } from './routes/auto-force-outs/index'
import { Route as AutoForceOutsParticipantsRouteImport } from './routes/auto-force-outs/participants'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns/index'
import { Route as CampaignsMessagesRouteImport } from './routes/campaigns/messages'
import { Route as CarriersIndexRouteImport } from './routes/carriers/index'
import { Route as CarriersAnnuityIntegrationIdRouteImport } from './routes/carriers/$annuityIntegrationId'
import { Route as ConnectivityIndexRouteImport } from './routes/connectivity/index'
import { Route as ConnectivityMapProvidersRouteImport } from './routes/connectivity/map-providers'
import { Route as ConnectivityMiscRouteImport } from './routes/connectivity/misc'
import { Route as ConnectivitySftpRouteImport } from './routes/connectivity/sftp'
import { Route as CronJobsIndexRouteImport } from './routes/cron-jobs/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DbInsightsIndexRouteImport } from './routes/db-insights/index'
import { Route as DbInsightsCollationsRouteImport } from './routes/db-insights/collations'
import { Route as DbInsightsDriftRouteImport } from './routes/db-insights/drift'
import { Route as DbInsightsSlowQueriesRouteImport } from './routes/db-insights/slow-queries'
import { Route as DbInsightsTablesRouteImport } from './routes/db-insights/tables'
import { Route as FlywayIndexRouteImport } from './routes/flyway/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as IntegrationsIntegrationIdRouteImport } from './routes/integrations/$integrationId'
import { Route as IraClarityIndexRouteImport } from './routes/ira-clarity/index'
import { Route as ManagedAccountProvidersManagedAccountProviderIdRouteImport } from './routes/managed-account-providers/$managedAccountProviderId'
import { Route as MethodologiesIndexRouteImport } from './routes/methodologies/index'
import { Route as MethodologiesManagedAccountMethodologyIdRouteImport } from './routes/methodologies/$managedAccountMethodologyId'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as OrganizationsAdvisoryOrganizationIdRouteImport } from './routes/organizations/$advisoryOrganizationId'
import { Route as ParticipantTransactionsIndexRouteImport } from './routes/participant-transactions/index'
import { Route as ParticipantTransactionsExportsRouteImport } from './routes/participant-transactions/exports'
import { Route as ParticipantsIndexRouteImport } from './routes/participants/index'
import { Route as QueuesIndexRouteImport } from './routes/queues/index'
import { Route as QueuesNameRouteImport } from './routes/queues/$name'
import { Route as QueuesSettingsRouteImport } from './routes/queues/settings'
import { Route as RecordkeepersIndexRouteImport } from './routes/recordkeepers/index'
import { Route as RecordkeepersRecordKeepingOrganizationIdRouteImport } from './routes/recordkeepers/$recordKeepingOrganizationId'
import { Route as RelationshipHealthIndexRouteImport } from './routes/relationship-health/index'
import { Route as RelationshipHealthLoginRouteImport } from './routes/relationship-health/login'
import { Route as RelationshipHealthParticipantsRouteImport } from './routes/relationship-health/participants'
import { Route as RelationshipHealthPlansRouteImport } from './routes/relationship-health/plans'
import { Route as S3BrowserIndexRouteImport } from './routes/s3-browser/index'
import { Route as S3BrowserBucketRouteImport } from './routes/s3-browser/$bucket'
import { Route as SubmissionLogIndexRouteImport } from './routes/submission-log/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as UsersLoginIdRouteImport } from './routes/users/$loginId'
import { Route as CarriersAnnuityIntegrationIdIndexRouteImport } from './routes/carriers/$annuityIntegrationId/index'
import { Route as CarriersAnnuityIntegrationIdApiKeysRouteImport } from './routes/carriers/$annuityIntegrationId/api-keys'
import { Route as CarriersAnnuityIntegrationIdExportsRouteImport } from './routes/carriers/$annuityIntegrationId/exports'
import { Route as CarriersAnnuityIntegrationIdTransactionsRouteImport } from './routes/carriers/$annuityIntegrationId/transactions'
import { Route as DbInsightsTablesIndexRouteImport } from './routes/db-insights/tables/index'
import { Route as DbInsightsTablesTableRouteImport } from './routes/db-insights/tables/$table'
import { Route as MethodologiesManagedAccountMethodologyIdIndexRouteImport } from './routes/methodologies/$managedAccountMethodologyId/index'
import { Route as MethodologiesManagedAccountMethodologyIdAssociationsRouteImport } from './routes/methodologies/$managedAccountMethodologyId/associations'
import { Route as MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRouteImport } from './routes/methodologies/$managedAccountMethodologyId/managed-account-providers'
import { Route as OrganizationsAdvisoryOrganizationIdIndexRouteImport } from './routes/organizations/$advisoryOrganizationId/index'
import { Route as OrganizationsAdvisoryOrganizationIdActivityMonitorRouteImport } from './routes/organizations/$advisoryOrganizationId/activity-monitor'
import { Route as OrganizationsAdvisoryOrganizationIdAdvisorsRouteImport } from './routes/organizations/$advisoryOrganizationId/advisors'
import { Route as OrganizationsAdvisoryOrganizationIdEditRouteImport } from './routes/organizations/$advisoryOrganizationId/edit'
import { Route as OrganizationsAdvisoryOrganizationIdIntegrationsRouteImport } from './routes/organizations/$advisoryOrganizationId/integrations'
import { Route as OrganizationsAdvisoryOrganizationIdLicensingRouteImport } from './routes/organizations/$advisoryOrganizationId/licensing'
import { Route as OrganizationsAdvisoryOrganizationIdManagedAccountsRouteImport } from './routes/organizations/$advisoryOrganizationId/managed-accounts'
import { Route as OrganizationsAdvisoryOrganizationIdRecordKeepersRouteImport } from './routes/organizations/$advisoryOrganizationId/record-keepers'
import { Route as OrganizationsAdvisoryOrganizationIdSubmissionLogRouteImport } from './routes/organizations/$advisoryOrganizationId/submission-log'
import { Route as OrganizationsAdvisoryOrganizationIdWhiteLabelsRouteImport } from './routes/organizations/$advisoryOrganizationId/white-labels'
import { Route as OrganizationsAdvisoryOrganizationIdParticipantsIndexRouteImport } from './routes/organizations/$advisoryOrganizationId/participants/index'
import { Route as OrganizationsAdvisoryOrganizationIdPlansIndexRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/index'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/index'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/advisors'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/core-calcs'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/equity-wash'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/funds'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/participants'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRouteImport } from './routes/organizations/$advisoryOrganizationId/plans/$planId/settings'
import { Route as OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRouteImport } from './routes/organizations/$advisoryOrganizationId/plans.$planId_.participants.$planEnrollmentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnuityAccountErrorsRoute = AnnuityAccountErrorsRouteImport.update({
  id: '/annuity-account-errors',
  path: '/annuity-account-errors',
  getParentRoute: () => rootRouteImport,
} as any)
const AutoForceOutsRoute = AutoForceOutsRouteImport.update({
  id: '/auto-force-outs',
  path: '/auto-force-outs',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsRoute = CampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectivityRoute = ConnectivityRouteImport.update({
  id: '/connectivity',
  path: '/connectivity',
  getParentRoute: () => rootRouteImport,
} as any)
const DbInsightsRoute = DbInsightsRouteImport.update({
  id: '/db-insights',
  path: '/db-insights',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ParticipantTransactionsRoute = ParticipantTransactionsRouteImport.update({
  id: '/participant-transactions',
  path: '/participant-transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const QueuesRoute = QueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => rootRouteImport,
} as any)
const RelationshipHealthRoute = RelationshipHealthRouteImport.update({
  id: '/relationship-health',
  path: '/relationship-health',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoErrorsRoute = SsoErrorsRouteImport.update({
  id: '/sso-errors',
  path: '/sso-errors',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityMonitorIndexRoute = ActivityMonitorIndexRouteImport.update({
  id: '/activity-monitor/',
  path: '/activity-monitor/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysIndexRoute = ApiKeysIndexRouteImport.update({
  id: '/api-keys/',
  path: '/api-keys/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutoForceOutsIndexRoute = AutoForceOutsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AutoForceOutsRoute,
} as any)
const AutoForceOutsParticipantsRoute =
  AutoForceOutsParticipantsRouteImport.update({
    id: '/participants',
    path: '/participants',
    getParentRoute: () => AutoForceOutsRoute,
  } as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsMessagesRoute = CampaignsMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => CampaignsRoute,
} as any)
const CarriersIndexRoute = CarriersIndexRouteImport.update({
  id: '/carriers/',
  path: '/carriers/',
  getParentRoute: () => rootRouteImport,
} as any)
const CarriersAnnuityIntegrationIdRoute =
  CarriersAnnuityIntegrationIdRouteImport.update({
    id: '/carriers/$annuityIntegrationId',
    path: '/carriers/$annuityIntegrationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConnectivityIndexRoute = ConnectivityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConnectivityRoute,
} as any)
const ConnectivityMapProvidersRoute =
  ConnectivityMapProvidersRouteImport.update({
    id: '/map-providers',
    path: '/map-providers',
    getParentRoute: () => ConnectivityRoute,
  } as any)
const ConnectivityMiscRoute = ConnectivityMiscRouteImport.update({
  id: '/misc',
  path: '/misc',
  getParentRoute: () => ConnectivityRoute,
} as any)
const ConnectivitySftpRoute = ConnectivitySftpRouteImport.update({
  id: '/sftp',
  path: '/sftp',
  getParentRoute: () => ConnectivityRoute,
} as any)
const CronJobsIndexRoute = CronJobsIndexRouteImport.update({
  id: '/cron-jobs/',
  path: '/cron-jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DbInsightsIndexRoute = DbInsightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DbInsightsRoute,
} as any)
const DbInsightsCollationsRoute = DbInsightsCollationsRouteImport.update({
  id: '/collations',
  path: '/collations',
  getParentRoute: () => DbInsightsRoute,
} as any)
const DbInsightsDriftRoute = DbInsightsDriftRouteImport.update({
  id: '/drift',
  path: '/drift',
  getParentRoute: () => DbInsightsRoute,
} as any)
const DbInsightsSlowQueriesRoute = DbInsightsSlowQueriesRouteImport.update({
  id: '/slow-queries',
  path: '/slow-queries',
  getParentRoute: () => DbInsightsRoute,
} as any)
const DbInsightsTablesRoute = DbInsightsTablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => DbInsightsRoute,
} as any)
const FlywayIndexRoute = FlywayIndexRouteImport.update({
  id: '/flyway/',
  path: '/flyway/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIntegrationIdRoute =
  IntegrationsIntegrationIdRouteImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const IraClarityIndexRoute = IraClarityIndexRouteImport.update({
  id: '/ira-clarity/',
  path: '/ira-clarity/',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagedAccountProvidersManagedAccountProviderIdRoute =
  ManagedAccountProvidersManagedAccountProviderIdRouteImport.update({
    id: '/managed-account-providers/$managedAccountProviderId',
    path: '/managed-account-providers/$managedAccountProviderId',
    getParentRoute: () => rootRouteImport,
  } as any)
const MethodologiesIndexRoute = MethodologiesIndexRouteImport.update({
  id: '/methodologies/',
  path: '/methodologies/',
  getParentRoute: () => rootRouteImport,
} as any)
const MethodologiesManagedAccountMethodologyIdRoute =
  MethodologiesManagedAccountMethodologyIdRouteImport.update({
    id: '/methodologies/$managedAccountMethodologyId',
    path: '/methodologies/$managedAccountMethodologyId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsAdvisoryOrganizationIdRoute =
  OrganizationsAdvisoryOrganizationIdRouteImport.update({
    id: '/organizations/$advisoryOrganizationId',
    path: '/organizations/$advisoryOrganizationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ParticipantTransactionsIndexRoute =
  ParticipantTransactionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ParticipantTransactionsRoute,
  } as any)
const ParticipantTransactionsExportsRoute =
  ParticipantTransactionsExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => ParticipantTransactionsRoute,
  } as any)
const ParticipantsIndexRoute = ParticipantsIndexRouteImport.update({
  id: '/participants/',
  path: '/participants/',
  getParentRoute: () => rootRouteImport,
} as any)
const QueuesIndexRoute = QueuesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => QueuesRoute,
} as any)
const QueuesNameRoute = QueuesNameRouteImport.update({
  id: '/$name',
  path: '/$name',
  getParentRoute: () => QueuesRoute,
} as any)
const QueuesSettingsRoute = QueuesSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => QueuesRoute,
} as any)
const RecordkeepersIndexRoute = RecordkeepersIndexRouteImport.update({
  id: '/recordkeepers/',
  path: '/recordkeepers/',
  getParentRoute: () => rootRouteImport,
} as any)
const RecordkeepersRecordKeepingOrganizationIdRoute =
  RecordkeepersRecordKeepingOrganizationIdRouteImport.update({
    id: '/recordkeepers/$recordKeepingOrganizationId',
    path: '/recordkeepers/$recordKeepingOrganizationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const RelationshipHealthIndexRoute = RelationshipHealthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RelationshipHealthRoute,
} as any)
const RelationshipHealthLoginRoute = RelationshipHealthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => RelationshipHealthRoute,
} as any)
const RelationshipHealthParticipantsRoute =
  RelationshipHealthParticipantsRouteImport.update({
    id: '/participants',
    path: '/participants',
    getParentRoute: () => RelationshipHealthRoute,
  } as any)
const RelationshipHealthPlansRoute = RelationshipHealthPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => RelationshipHealthRoute,
} as any)
const S3BrowserIndexRoute = S3BrowserIndexRouteImport.update({
  id: '/s3-browser/',
  path: '/s3-browser/',
  getParentRoute: () => rootRouteImport,
} as any)
const S3BrowserBucketRoute = S3BrowserBucketRouteImport.update({
  id: '/s3-browser/$bucket',
  path: '/s3-browser/$bucket',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmissionLogIndexRoute = SubmissionLogIndexRouteImport.update({
  id: '/submission-log/',
  path: '/submission-log/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersLoginIdRoute = UsersLoginIdRouteImport.update({
  id: '/users/$loginId',
  path: '/users/$loginId',
  getParentRoute: () => rootRouteImport,
} as any)
const CarriersAnnuityIntegrationIdIndexRoute =
  CarriersAnnuityIntegrationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CarriersAnnuityIntegrationIdRoute,
  } as any)
const CarriersAnnuityIntegrationIdApiKeysRoute =
  CarriersAnnuityIntegrationIdApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => CarriersAnnuityIntegrationIdRoute,
  } as any)
const CarriersAnnuityIntegrationIdExportsRoute =
  CarriersAnnuityIntegrationIdExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => CarriersAnnuityIntegrationIdRoute,
  } as any)
const CarriersAnnuityIntegrationIdTransactionsRoute =
  CarriersAnnuityIntegrationIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => CarriersAnnuityIntegrationIdRoute,
  } as any)
const DbInsightsTablesIndexRoute = DbInsightsTablesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DbInsightsTablesRoute,
} as any)
const DbInsightsTablesTableRoute = DbInsightsTablesTableRouteImport.update({
  id: '/$table',
  path: '/$table',
  getParentRoute: () => DbInsightsTablesRoute,
} as any)
const MethodologiesManagedAccountMethodologyIdIndexRoute =
  MethodologiesManagedAccountMethodologyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MethodologiesManagedAccountMethodologyIdRoute,
  } as any)
const MethodologiesManagedAccountMethodologyIdAssociationsRoute =
  MethodologiesManagedAccountMethodologyIdAssociationsRouteImport.update({
    id: '/associations',
    path: '/associations',
    getParentRoute: () => MethodologiesManagedAccountMethodologyIdRoute,
  } as any)
const MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute =
  MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRouteImport.update(
    {
      id: '/managed-account-providers',
      path: '/managed-account-providers',
      getParentRoute: () => MethodologiesManagedAccountMethodologyIdRoute,
    } as any,
  )
const OrganizationsAdvisoryOrganizationIdIndexRoute =
  OrganizationsAdvisoryOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdActivityMonitorRoute =
  OrganizationsAdvisoryOrganizationIdActivityMonitorRouteImport.update({
    id: '/activity-monitor',
    path: '/activity-monitor',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdAdvisorsRoute =
  OrganizationsAdvisoryOrganizationIdAdvisorsRouteImport.update({
    id: '/advisors',
    path: '/advisors',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdEditRoute =
  OrganizationsAdvisoryOrganizationIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdIntegrationsRoute =
  OrganizationsAdvisoryOrganizationIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdLicensingRoute =
  OrganizationsAdvisoryOrganizationIdLicensingRouteImport.update({
    id: '/licensing',
    path: '/licensing',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdManagedAccountsRoute =
  OrganizationsAdvisoryOrganizationIdManagedAccountsRouteImport.update({
    id: '/managed-accounts',
    path: '/managed-accounts',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdRecordKeepersRoute =
  OrganizationsAdvisoryOrganizationIdRecordKeepersRouteImport.update({
    id: '/record-keepers',
    path: '/record-keepers',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdSubmissionLogRoute =
  OrganizationsAdvisoryOrganizationIdSubmissionLogRouteImport.update({
    id: '/submission-log',
    path: '/submission-log',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute =
  OrganizationsAdvisoryOrganizationIdWhiteLabelsRouteImport.update({
    id: '/white-labels',
    path: '/white-labels',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute =
  OrganizationsAdvisoryOrganizationIdParticipantsIndexRouteImport.update({
    id: '/participants/',
    path: '/participants/',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansIndexRoute =
  OrganizationsAdvisoryOrganizationIdPlansIndexRouteImport.update({
    id: '/plans/',
    path: '/plans/',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteImport.update({
    id: '/plans/$planId',
    path: '/plans/$planId',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRouteImport.update({
    id: '/advisors',
    path: '/advisors',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRouteImport.update({
    id: '/core-calcs',
    path: '/core-calcs',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRouteImport.update({
    id: '/equity-wash',
    path: '/equity-wash',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRouteImport.update({
    id: '/funds',
    path: '/funds',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRouteImport.update(
    {
      id: '/managed-account-program',
      path: '/managed-account-program',
      getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
    } as any,
  )
const OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRouteImport.update({
    id: '/participants',
    path: '/participants',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute,
  } as any)
const OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRouteImport.update(
    {
      id: '/plans/$planId_/participants/$planEnrollmentId',
      path: '/plans/$planId/participants/$planEnrollmentId',
      getParentRoute: () => OrganizationsAdvisoryOrganizationIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/annuity-account-errors': typeof AnnuityAccountErrorsRoute
  '/auto-force-outs': typeof AutoForceOutsRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/connectivity': typeof ConnectivityRouteWithChildren
  '/db-insights': typeof DbInsightsRouteWithChildren
  '/login': typeof LoginRoute
  '/participant-transactions': typeof ParticipantTransactionsRouteWithChildren
  '/queues': typeof QueuesRouteWithChildren
  '/relationship-health': typeof RelationshipHealthRouteWithChildren
  '/setup': typeof SetupRoute
  '/sso-errors': typeof SsoErrorsRoute
  '/auto-force-outs/participants': typeof AutoForceOutsParticipantsRoute
  '/campaigns/messages': typeof CampaignsMessagesRoute
  '/carriers/$annuityIntegrationId': typeof CarriersAnnuityIntegrationIdRouteWithChildren
  '/connectivity/map-providers': typeof ConnectivityMapProvidersRoute
  '/connectivity/misc': typeof ConnectivityMiscRoute
  '/connectivity/sftp': typeof ConnectivitySftpRoute
  '/db-insights/collations': typeof DbInsightsCollationsRoute
  '/db-insights/drift': typeof DbInsightsDriftRoute
  '/db-insights/slow-queries': typeof DbInsightsSlowQueriesRoute
  '/db-insights/tables': typeof DbInsightsTablesRouteWithChildren
  '/integrations/$integrationId': typeof IntegrationsIntegrationIdRoute
  '/managed-account-providers/$managedAccountProviderId': typeof ManagedAccountProvidersManagedAccountProviderIdRoute
  '/methodologies/$managedAccountMethodologyId': typeof MethodologiesManagedAccountMethodologyIdRouteWithChildren
  '/organizations/$advisoryOrganizationId': typeof OrganizationsAdvisoryOrganizationIdRouteWithChildren
  '/participant-transactions/exports': typeof ParticipantTransactionsExportsRoute
  '/queues/$name': typeof QueuesNameRoute
  '/queues/settings': typeof QueuesSettingsRoute
  '/recordkeepers/$recordKeepingOrganizationId': typeof RecordkeepersRecordKeepingOrganizationIdRoute
  '/relationship-health/login': typeof RelationshipHealthLoginRoute
  '/relationship-health/participants': typeof RelationshipHealthParticipantsRoute
  '/relationship-health/plans': typeof RelationshipHealthPlansRoute
  '/s3-browser/$bucket': typeof S3BrowserBucketRoute
  '/users/$loginId': typeof UsersLoginIdRoute
  '/activity-monitor/': typeof ActivityMonitorIndexRoute
  '/api-keys/': typeof ApiKeysIndexRoute
  '/auto-force-outs/': typeof AutoForceOutsIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/carriers/': typeof CarriersIndexRoute
  '/connectivity/': typeof ConnectivityIndexRoute
  '/cron-jobs/': typeof CronJobsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/db-insights/': typeof DbInsightsIndexRoute
  '/flyway/': typeof FlywayIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/ira-clarity/': typeof IraClarityIndexRoute
  '/methodologies/': typeof MethodologiesIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/participant-transactions/': typeof ParticipantTransactionsIndexRoute
  '/participants/': typeof ParticipantsIndexRoute
  '/queues/': typeof QueuesIndexRoute
  '/recordkeepers/': typeof RecordkeepersIndexRoute
  '/relationship-health/': typeof RelationshipHealthIndexRoute
  '/s3-browser/': typeof S3BrowserIndexRoute
  '/submission-log/': typeof SubmissionLogIndexRoute
  '/users/': typeof UsersIndexRoute
  '/carriers/$annuityIntegrationId/api-keys': typeof CarriersAnnuityIntegrationIdApiKeysRoute
  '/carriers/$annuityIntegrationId/exports': typeof CarriersAnnuityIntegrationIdExportsRoute
  '/carriers/$annuityIntegrationId/transactions': typeof CarriersAnnuityIntegrationIdTransactionsRoute
  '/db-insights/tables/$table': typeof DbInsightsTablesTableRoute
  '/methodologies/$managedAccountMethodologyId/associations': typeof MethodologiesManagedAccountMethodologyIdAssociationsRoute
  '/methodologies/$managedAccountMethodologyId/managed-account-providers': typeof MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute
  '/organizations/$advisoryOrganizationId/activity-monitor': typeof OrganizationsAdvisoryOrganizationIdActivityMonitorRoute
  '/organizations/$advisoryOrganizationId/advisors': typeof OrganizationsAdvisoryOrganizationIdAdvisorsRoute
  '/organizations/$advisoryOrganizationId/edit': typeof OrganizationsAdvisoryOrganizationIdEditRoute
  '/organizations/$advisoryOrganizationId/integrations': typeof OrganizationsAdvisoryOrganizationIdIntegrationsRoute
  '/organizations/$advisoryOrganizationId/licensing': typeof OrganizationsAdvisoryOrganizationIdLicensingRoute
  '/organizations/$advisoryOrganizationId/managed-accounts': typeof OrganizationsAdvisoryOrganizationIdManagedAccountsRoute
  '/organizations/$advisoryOrganizationId/record-keepers': typeof OrganizationsAdvisoryOrganizationIdRecordKeepersRoute
  '/organizations/$advisoryOrganizationId/submission-log': typeof OrganizationsAdvisoryOrganizationIdSubmissionLogRoute
  '/organizations/$advisoryOrganizationId/white-labels': typeof OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute
  '/carriers/$annuityIntegrationId/': typeof CarriersAnnuityIntegrationIdIndexRoute
  '/db-insights/tables/': typeof DbInsightsTablesIndexRoute
  '/methodologies/$managedAccountMethodologyId/': typeof MethodologiesManagedAccountMethodologyIdIndexRoute
  '/organizations/$advisoryOrganizationId/': typeof OrganizationsAdvisoryOrganizationIdIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteWithChildren
  '/organizations/$advisoryOrganizationId/participants/': typeof OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute
  '/organizations/$advisoryOrganizationId/plans/': typeof OrganizationsAdvisoryOrganizationIdPlansIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/advisors': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/funds': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/participants': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/settings': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/participants/$planEnrollmentId': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/annuity-account-errors': typeof AnnuityAccountErrorsRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/sso-errors': typeof SsoErrorsRoute
  '/auto-force-outs/participants': typeof AutoForceOutsParticipantsRoute
  '/campaigns/messages': typeof CampaignsMessagesRoute
  '/connectivity/map-providers': typeof ConnectivityMapProvidersRoute
  '/connectivity/misc': typeof ConnectivityMiscRoute
  '/connectivity/sftp': typeof ConnectivitySftpRoute
  '/db-insights/collations': typeof DbInsightsCollationsRoute
  '/db-insights/drift': typeof DbInsightsDriftRoute
  '/db-insights/slow-queries': typeof DbInsightsSlowQueriesRoute
  '/integrations/$integrationId': typeof IntegrationsIntegrationIdRoute
  '/managed-account-providers/$managedAccountProviderId': typeof ManagedAccountProvidersManagedAccountProviderIdRoute
  '/participant-transactions/exports': typeof ParticipantTransactionsExportsRoute
  '/queues/$name': typeof QueuesNameRoute
  '/queues/settings': typeof QueuesSettingsRoute
  '/recordkeepers/$recordKeepingOrganizationId': typeof RecordkeepersRecordKeepingOrganizationIdRoute
  '/relationship-health/login': typeof RelationshipHealthLoginRoute
  '/relationship-health/participants': typeof RelationshipHealthParticipantsRoute
  '/relationship-health/plans': typeof RelationshipHealthPlansRoute
  '/s3-browser/$bucket': typeof S3BrowserBucketRoute
  '/users/$loginId': typeof UsersLoginIdRoute
  '/activity-monitor': typeof ActivityMonitorIndexRoute
  '/api-keys': typeof ApiKeysIndexRoute
  '/auto-force-outs': typeof AutoForceOutsIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/carriers': typeof CarriersIndexRoute
  '/connectivity': typeof ConnectivityIndexRoute
  '/cron-jobs': typeof CronJobsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/db-insights': typeof DbInsightsIndexRoute
  '/flyway': typeof FlywayIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/ira-clarity': typeof IraClarityIndexRoute
  '/methodologies': typeof MethodologiesIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/participant-transactions': typeof ParticipantTransactionsIndexRoute
  '/participants': typeof ParticipantsIndexRoute
  '/queues': typeof QueuesIndexRoute
  '/recordkeepers': typeof RecordkeepersIndexRoute
  '/relationship-health': typeof RelationshipHealthIndexRoute
  '/s3-browser': typeof S3BrowserIndexRoute
  '/submission-log': typeof SubmissionLogIndexRoute
  '/users': typeof UsersIndexRoute
  '/carriers/$annuityIntegrationId/api-keys': typeof CarriersAnnuityIntegrationIdApiKeysRoute
  '/carriers/$annuityIntegrationId/exports': typeof CarriersAnnuityIntegrationIdExportsRoute
  '/carriers/$annuityIntegrationId/transactions': typeof CarriersAnnuityIntegrationIdTransactionsRoute
  '/db-insights/tables/$table': typeof DbInsightsTablesTableRoute
  '/methodologies/$managedAccountMethodologyId/associations': typeof MethodologiesManagedAccountMethodologyIdAssociationsRoute
  '/methodologies/$managedAccountMethodologyId/managed-account-providers': typeof MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute
  '/organizations/$advisoryOrganizationId/activity-monitor': typeof OrganizationsAdvisoryOrganizationIdActivityMonitorRoute
  '/organizations/$advisoryOrganizationId/advisors': typeof OrganizationsAdvisoryOrganizationIdAdvisorsRoute
  '/organizations/$advisoryOrganizationId/edit': typeof OrganizationsAdvisoryOrganizationIdEditRoute
  '/organizations/$advisoryOrganizationId/integrations': typeof OrganizationsAdvisoryOrganizationIdIntegrationsRoute
  '/organizations/$advisoryOrganizationId/licensing': typeof OrganizationsAdvisoryOrganizationIdLicensingRoute
  '/organizations/$advisoryOrganizationId/managed-accounts': typeof OrganizationsAdvisoryOrganizationIdManagedAccountsRoute
  '/organizations/$advisoryOrganizationId/record-keepers': typeof OrganizationsAdvisoryOrganizationIdRecordKeepersRoute
  '/organizations/$advisoryOrganizationId/submission-log': typeof OrganizationsAdvisoryOrganizationIdSubmissionLogRoute
  '/organizations/$advisoryOrganizationId/white-labels': typeof OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute
  '/carriers/$annuityIntegrationId': typeof CarriersAnnuityIntegrationIdIndexRoute
  '/db-insights/tables': typeof DbInsightsTablesIndexRoute
  '/methodologies/$managedAccountMethodologyId': typeof MethodologiesManagedAccountMethodologyIdIndexRoute
  '/organizations/$advisoryOrganizationId': typeof OrganizationsAdvisoryOrganizationIdIndexRoute
  '/organizations/$advisoryOrganizationId/participants': typeof OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute
  '/organizations/$advisoryOrganizationId/plans': typeof OrganizationsAdvisoryOrganizationIdPlansIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/advisors': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/funds': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/participants': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/settings': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/participants/$planEnrollmentId': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/annuity-account-errors': typeof AnnuityAccountErrorsRoute
  '/auto-force-outs': typeof AutoForceOutsRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/connectivity': typeof ConnectivityRouteWithChildren
  '/db-insights': typeof DbInsightsRouteWithChildren
  '/login': typeof LoginRoute
  '/participant-transactions': typeof ParticipantTransactionsRouteWithChildren
  '/queues': typeof QueuesRouteWithChildren
  '/relationship-health': typeof RelationshipHealthRouteWithChildren
  '/setup': typeof SetupRoute
  '/sso-errors': typeof SsoErrorsRoute
  '/auto-force-outs/participants': typeof AutoForceOutsParticipantsRoute
  '/campaigns/messages': typeof CampaignsMessagesRoute
  '/carriers/$annuityIntegrationId': typeof CarriersAnnuityIntegrationIdRouteWithChildren
  '/connectivity/map-providers': typeof ConnectivityMapProvidersRoute
  '/connectivity/misc': typeof ConnectivityMiscRoute
  '/connectivity/sftp': typeof ConnectivitySftpRoute
  '/db-insights/collations': typeof DbInsightsCollationsRoute
  '/db-insights/drift': typeof DbInsightsDriftRoute
  '/db-insights/slow-queries': typeof DbInsightsSlowQueriesRoute
  '/db-insights/tables': typeof DbInsightsTablesRouteWithChildren
  '/integrations/$integrationId': typeof IntegrationsIntegrationIdRoute
  '/managed-account-providers/$managedAccountProviderId': typeof ManagedAccountProvidersManagedAccountProviderIdRoute
  '/methodologies/$managedAccountMethodologyId': typeof MethodologiesManagedAccountMethodologyIdRouteWithChildren
  '/organizations/$advisoryOrganizationId': typeof OrganizationsAdvisoryOrganizationIdRouteWithChildren
  '/participant-transactions/exports': typeof ParticipantTransactionsExportsRoute
  '/queues/$name': typeof QueuesNameRoute
  '/queues/settings': typeof QueuesSettingsRoute
  '/recordkeepers/$recordKeepingOrganizationId': typeof RecordkeepersRecordKeepingOrganizationIdRoute
  '/relationship-health/login': typeof RelationshipHealthLoginRoute
  '/relationship-health/participants': typeof RelationshipHealthParticipantsRoute
  '/relationship-health/plans': typeof RelationshipHealthPlansRoute
  '/s3-browser/$bucket': typeof S3BrowserBucketRoute
  '/users/$loginId': typeof UsersLoginIdRoute
  '/activity-monitor/': typeof ActivityMonitorIndexRoute
  '/api-keys/': typeof ApiKeysIndexRoute
  '/auto-force-outs/': typeof AutoForceOutsIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/carriers/': typeof CarriersIndexRoute
  '/connectivity/': typeof ConnectivityIndexRoute
  '/cron-jobs/': typeof CronJobsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/db-insights/': typeof DbInsightsIndexRoute
  '/flyway/': typeof FlywayIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/ira-clarity/': typeof IraClarityIndexRoute
  '/methodologies/': typeof MethodologiesIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/participant-transactions/': typeof ParticipantTransactionsIndexRoute
  '/participants/': typeof ParticipantsIndexRoute
  '/queues/': typeof QueuesIndexRoute
  '/recordkeepers/': typeof RecordkeepersIndexRoute
  '/relationship-health/': typeof RelationshipHealthIndexRoute
  '/s3-browser/': typeof S3BrowserIndexRoute
  '/submission-log/': typeof SubmissionLogIndexRoute
  '/users/': typeof UsersIndexRoute
  '/carriers/$annuityIntegrationId/api-keys': typeof CarriersAnnuityIntegrationIdApiKeysRoute
  '/carriers/$annuityIntegrationId/exports': typeof CarriersAnnuityIntegrationIdExportsRoute
  '/carriers/$annuityIntegrationId/transactions': typeof CarriersAnnuityIntegrationIdTransactionsRoute
  '/db-insights/tables/$table': typeof DbInsightsTablesTableRoute
  '/methodologies/$managedAccountMethodologyId/associations': typeof MethodologiesManagedAccountMethodologyIdAssociationsRoute
  '/methodologies/$managedAccountMethodologyId/managed-account-providers': typeof MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute
  '/organizations/$advisoryOrganizationId/activity-monitor': typeof OrganizationsAdvisoryOrganizationIdActivityMonitorRoute
  '/organizations/$advisoryOrganizationId/advisors': typeof OrganizationsAdvisoryOrganizationIdAdvisorsRoute
  '/organizations/$advisoryOrganizationId/edit': typeof OrganizationsAdvisoryOrganizationIdEditRoute
  '/organizations/$advisoryOrganizationId/integrations': typeof OrganizationsAdvisoryOrganizationIdIntegrationsRoute
  '/organizations/$advisoryOrganizationId/licensing': typeof OrganizationsAdvisoryOrganizationIdLicensingRoute
  '/organizations/$advisoryOrganizationId/managed-accounts': typeof OrganizationsAdvisoryOrganizationIdManagedAccountsRoute
  '/organizations/$advisoryOrganizationId/record-keepers': typeof OrganizationsAdvisoryOrganizationIdRecordKeepersRoute
  '/organizations/$advisoryOrganizationId/submission-log': typeof OrganizationsAdvisoryOrganizationIdSubmissionLogRoute
  '/organizations/$advisoryOrganizationId/white-labels': typeof OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute
  '/carriers/$annuityIntegrationId/': typeof CarriersAnnuityIntegrationIdIndexRoute
  '/db-insights/tables/': typeof DbInsightsTablesIndexRoute
  '/methodologies/$managedAccountMethodologyId/': typeof MethodologiesManagedAccountMethodologyIdIndexRoute
  '/organizations/$advisoryOrganizationId/': typeof OrganizationsAdvisoryOrganizationIdIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteWithChildren
  '/organizations/$advisoryOrganizationId/participants/': typeof OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute
  '/organizations/$advisoryOrganizationId/plans/': typeof OrganizationsAdvisoryOrganizationIdPlansIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/advisors': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/funds': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/participants': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/settings': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute
  '/organizations/$advisoryOrganizationId/plans/$planId/': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute
  '/organizations/$advisoryOrganizationId/plans/$planId_/participants/$planEnrollmentId': typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/annuity-account-errors'
    | '/auto-force-outs'
    | '/campaigns'
    | '/connectivity'
    | '/db-insights'
    | '/login'
    | '/participant-transactions'
    | '/queues'
    | '/relationship-health'
    | '/setup'
    | '/sso-errors'
    | '/auto-force-outs/participants'
    | '/campaigns/messages'
    | '/carriers/$annuityIntegrationId'
    | '/connectivity/map-providers'
    | '/connectivity/misc'
    | '/connectivity/sftp'
    | '/db-insights/collations'
    | '/db-insights/drift'
    | '/db-insights/slow-queries'
    | '/db-insights/tables'
    | '/integrations/$integrationId'
    | '/managed-account-providers/$managedAccountProviderId'
    | '/methodologies/$managedAccountMethodologyId'
    | '/organizations/$advisoryOrganizationId'
    | '/participant-transactions/exports'
    | '/queues/$name'
    | '/queues/settings'
    | '/recordkeepers/$recordKeepingOrganizationId'
    | '/relationship-health/login'
    | '/relationship-health/participants'
    | '/relationship-health/plans'
    | '/s3-browser/$bucket'
    | '/users/$loginId'
    | '/activity-monitor/'
    | '/api-keys/'
    | '/auto-force-outs/'
    | '/campaigns/'
    | '/carriers/'
    | '/connectivity/'
    | '/cron-jobs/'
    | '/dashboard/'
    | '/db-insights/'
    | '/flyway/'
    | '/integrations/'
    | '/ira-clarity/'
    | '/methodologies/'
    | '/organizations/'
    | '/participant-transactions/'
    | '/participants/'
    | '/queues/'
    | '/recordkeepers/'
    | '/relationship-health/'
    | '/s3-browser/'
    | '/submission-log/'
    | '/users/'
    | '/carriers/$annuityIntegrationId/api-keys'
    | '/carriers/$annuityIntegrationId/exports'
    | '/carriers/$annuityIntegrationId/transactions'
    | '/db-insights/tables/$table'
    | '/methodologies/$managedAccountMethodologyId/associations'
    | '/methodologies/$managedAccountMethodologyId/managed-account-providers'
    | '/organizations/$advisoryOrganizationId/activity-monitor'
    | '/organizations/$advisoryOrganizationId/advisors'
    | '/organizations/$advisoryOrganizationId/edit'
    | '/organizations/$advisoryOrganizationId/integrations'
    | '/organizations/$advisoryOrganizationId/licensing'
    | '/organizations/$advisoryOrganizationId/managed-accounts'
    | '/organizations/$advisoryOrganizationId/record-keepers'
    | '/organizations/$advisoryOrganizationId/submission-log'
    | '/organizations/$advisoryOrganizationId/white-labels'
    | '/carriers/$annuityIntegrationId/'
    | '/db-insights/tables/'
    | '/methodologies/$managedAccountMethodologyId/'
    | '/organizations/$advisoryOrganizationId/'
    | '/organizations/$advisoryOrganizationId/plans/$planId'
    | '/organizations/$advisoryOrganizationId/participants/'
    | '/organizations/$advisoryOrganizationId/plans/'
    | '/organizations/$advisoryOrganizationId/plans/$planId/advisors'
    | '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs'
    | '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash'
    | '/organizations/$advisoryOrganizationId/plans/$planId/funds'
    | '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program'
    | '/organizations/$advisoryOrganizationId/plans/$planId/participants'
    | '/organizations/$advisoryOrganizationId/plans/$planId/settings'
    | '/organizations/$advisoryOrganizationId/plans/$planId/'
    | '/organizations/$advisoryOrganizationId/plans/$planId/participants/$planEnrollmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/annuity-account-errors'
    | '/login'
    | '/setup'
    | '/sso-errors'
    | '/auto-force-outs/participants'
    | '/campaigns/messages'
    | '/connectivity/map-providers'
    | '/connectivity/misc'
    | '/connectivity/sftp'
    | '/db-insights/collations'
    | '/db-insights/drift'
    | '/db-insights/slow-queries'
    | '/integrations/$integrationId'
    | '/managed-account-providers/$managedAccountProviderId'
    | '/participant-transactions/exports'
    | '/queues/$name'
    | '/queues/settings'
    | '/recordkeepers/$recordKeepingOrganizationId'
    | '/relationship-health/login'
    | '/relationship-health/participants'
    | '/relationship-health/plans'
    | '/s3-browser/$bucket'
    | '/users/$loginId'
    | '/activity-monitor'
    | '/api-keys'
    | '/auto-force-outs'
    | '/campaigns'
    | '/carriers'
    | '/connectivity'
    | '/cron-jobs'
    | '/dashboard'
    | '/db-insights'
    | '/flyway'
    | '/integrations'
    | '/ira-clarity'
    | '/methodologies'
    | '/organizations'
    | '/participant-transactions'
    | '/participants'
    | '/queues'
    | '/recordkeepers'
    | '/relationship-health'
    | '/s3-browser'
    | '/submission-log'
    | '/users'
    | '/carriers/$annuityIntegrationId/api-keys'
    | '/carriers/$annuityIntegrationId/exports'
    | '/carriers/$annuityIntegrationId/transactions'
    | '/db-insights/tables/$table'
    | '/methodologies/$managedAccountMethodologyId/associations'
    | '/methodologies/$managedAccountMethodologyId/managed-account-providers'
    | '/organizations/$advisoryOrganizationId/activity-monitor'
    | '/organizations/$advisoryOrganizationId/advisors'
    | '/organizations/$advisoryOrganizationId/edit'
    | '/organizations/$advisoryOrganizationId/integrations'
    | '/organizations/$advisoryOrganizationId/licensing'
    | '/organizations/$advisoryOrganizationId/managed-accounts'
    | '/organizations/$advisoryOrganizationId/record-keepers'
    | '/organizations/$advisoryOrganizationId/submission-log'
    | '/organizations/$advisoryOrganizationId/white-labels'
    | '/carriers/$annuityIntegrationId'
    | '/db-insights/tables'
    | '/methodologies/$managedAccountMethodologyId'
    | '/organizations/$advisoryOrganizationId'
    | '/organizations/$advisoryOrganizationId/participants'
    | '/organizations/$advisoryOrganizationId/plans'
    | '/organizations/$advisoryOrganizationId/plans/$planId/advisors'
    | '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs'
    | '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash'
    | '/organizations/$advisoryOrganizationId/plans/$planId/funds'
    | '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program'
    | '/organizations/$advisoryOrganizationId/plans/$planId/participants'
    | '/organizations/$advisoryOrganizationId/plans/$planId/settings'
    | '/organizations/$advisoryOrganizationId/plans/$planId'
    | '/organizations/$advisoryOrganizationId/plans/$planId/participants/$planEnrollmentId'
  id:
    | '__root__'
    | '/'
    | '/annuity-account-errors'
    | '/auto-force-outs'
    | '/campaigns'
    | '/connectivity'
    | '/db-insights'
    | '/login'
    | '/participant-transactions'
    | '/queues'
    | '/relationship-health'
    | '/setup'
    | '/sso-errors'
    | '/auto-force-outs/participants'
    | '/campaigns/messages'
    | '/carriers/$annuityIntegrationId'
    | '/connectivity/map-providers'
    | '/connectivity/misc'
    | '/connectivity/sftp'
    | '/db-insights/collations'
    | '/db-insights/drift'
    | '/db-insights/slow-queries'
    | '/db-insights/tables'
    | '/integrations/$integrationId'
    | '/managed-account-providers/$managedAccountProviderId'
    | '/methodologies/$managedAccountMethodologyId'
    | '/organizations/$advisoryOrganizationId'
    | '/participant-transactions/exports'
    | '/queues/$name'
    | '/queues/settings'
    | '/recordkeepers/$recordKeepingOrganizationId'
    | '/relationship-health/login'
    | '/relationship-health/participants'
    | '/relationship-health/plans'
    | '/s3-browser/$bucket'
    | '/users/$loginId'
    | '/activity-monitor/'
    | '/api-keys/'
    | '/auto-force-outs/'
    | '/campaigns/'
    | '/carriers/'
    | '/connectivity/'
    | '/cron-jobs/'
    | '/dashboard/'
    | '/db-insights/'
    | '/flyway/'
    | '/integrations/'
    | '/ira-clarity/'
    | '/methodologies/'
    | '/organizations/'
    | '/participant-transactions/'
    | '/participants/'
    | '/queues/'
    | '/recordkeepers/'
    | '/relationship-health/'
    | '/s3-browser/'
    | '/submission-log/'
    | '/users/'
    | '/carriers/$annuityIntegrationId/api-keys'
    | '/carriers/$annuityIntegrationId/exports'
    | '/carriers/$annuityIntegrationId/transactions'
    | '/db-insights/tables/$table'
    | '/methodologies/$managedAccountMethodologyId/associations'
    | '/methodologies/$managedAccountMethodologyId/managed-account-providers'
    | '/organizations/$advisoryOrganizationId/activity-monitor'
    | '/organizations/$advisoryOrganizationId/advisors'
    | '/organizations/$advisoryOrganizationId/edit'
    | '/organizations/$advisoryOrganizationId/integrations'
    | '/organizations/$advisoryOrganizationId/licensing'
    | '/organizations/$advisoryOrganizationId/managed-accounts'
    | '/organizations/$advisoryOrganizationId/record-keepers'
    | '/organizations/$advisoryOrganizationId/submission-log'
    | '/organizations/$advisoryOrganizationId/white-labels'
    | '/carriers/$annuityIntegrationId/'
    | '/db-insights/tables/'
    | '/methodologies/$managedAccountMethodologyId/'
    | '/organizations/$advisoryOrganizationId/'
    | '/organizations/$advisoryOrganizationId/plans/$planId'
    | '/organizations/$advisoryOrganizationId/participants/'
    | '/organizations/$advisoryOrganizationId/plans/'
    | '/organizations/$advisoryOrganizationId/plans/$planId/advisors'
    | '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs'
    | '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash'
    | '/organizations/$advisoryOrganizationId/plans/$planId/funds'
    | '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program'
    | '/organizations/$advisoryOrganizationId/plans/$planId/participants'
    | '/organizations/$advisoryOrganizationId/plans/$planId/settings'
    | '/organizations/$advisoryOrganizationId/plans/$planId/'
    | '/organizations/$advisoryOrganizationId/plans/$planId_/participants/$planEnrollmentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnnuityAccountErrorsRoute: typeof AnnuityAccountErrorsRoute
  AutoForceOutsRoute: typeof AutoForceOutsRouteWithChildren
  CampaignsRoute: typeof CampaignsRouteWithChildren
  ConnectivityRoute: typeof ConnectivityRouteWithChildren
  DbInsightsRoute: typeof DbInsightsRouteWithChildren
  LoginRoute: typeof LoginRoute
  ParticipantTransactionsRoute: typeof ParticipantTransactionsRouteWithChildren
  QueuesRoute: typeof QueuesRouteWithChildren
  RelationshipHealthRoute: typeof RelationshipHealthRouteWithChildren
  SetupRoute: typeof SetupRoute
  SsoErrorsRoute: typeof SsoErrorsRoute
  CarriersAnnuityIntegrationIdRoute: typeof CarriersAnnuityIntegrationIdRouteWithChildren
  IntegrationsIntegrationIdRoute: typeof IntegrationsIntegrationIdRoute
  ManagedAccountProvidersManagedAccountProviderIdRoute: typeof ManagedAccountProvidersManagedAccountProviderIdRoute
  MethodologiesManagedAccountMethodologyIdRoute: typeof MethodologiesManagedAccountMethodologyIdRouteWithChildren
  OrganizationsAdvisoryOrganizationIdRoute: typeof OrganizationsAdvisoryOrganizationIdRouteWithChildren
  RecordkeepersRecordKeepingOrganizationIdRoute: typeof RecordkeepersRecordKeepingOrganizationIdRoute
  S3BrowserBucketRoute: typeof S3BrowserBucketRoute
  UsersLoginIdRoute: typeof UsersLoginIdRoute
  ActivityMonitorIndexRoute: typeof ActivityMonitorIndexRoute
  ApiKeysIndexRoute: typeof ApiKeysIndexRoute
  CarriersIndexRoute: typeof CarriersIndexRoute
  CronJobsIndexRoute: typeof CronJobsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  FlywayIndexRoute: typeof FlywayIndexRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  IraClarityIndexRoute: typeof IraClarityIndexRoute
  MethodologiesIndexRoute: typeof MethodologiesIndexRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
  ParticipantsIndexRoute: typeof ParticipantsIndexRoute
  RecordkeepersIndexRoute: typeof RecordkeepersIndexRoute
  S3BrowserIndexRoute: typeof S3BrowserIndexRoute
  SubmissionLogIndexRoute: typeof SubmissionLogIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/annuity-account-errors': {
      id: '/annuity-account-errors'
      path: '/annuity-account-errors'
      fullPath: '/annuity-account-errors'
      preLoaderRoute: typeof AnnuityAccountErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auto-force-outs': {
      id: '/auto-force-outs'
      path: '/auto-force-outs'
      fullPath: '/auto-force-outs'
      preLoaderRoute: typeof AutoForceOutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connectivity': {
      id: '/connectivity'
      path: '/connectivity'
      fullPath: '/connectivity'
      preLoaderRoute: typeof ConnectivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/db-insights': {
      id: '/db-insights'
      path: '/db-insights'
      fullPath: '/db-insights'
      preLoaderRoute: typeof DbInsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/participant-transactions': {
      id: '/participant-transactions'
      path: '/participant-transactions'
      fullPath: '/participant-transactions'
      preLoaderRoute: typeof ParticipantTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queues': {
      id: '/queues'
      path: '/queues'
      fullPath: '/queues'
      preLoaderRoute: typeof QueuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relationship-health': {
      id: '/relationship-health'
      path: '/relationship-health'
      fullPath: '/relationship-health'
      preLoaderRoute: typeof RelationshipHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-errors': {
      id: '/sso-errors'
      path: '/sso-errors'
      fullPath: '/sso-errors'
      preLoaderRoute: typeof SsoErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity-monitor/': {
      id: '/activity-monitor/'
      path: '/activity-monitor'
      fullPath: '/activity-monitor/'
      preLoaderRoute: typeof ActivityMonitorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys/': {
      id: '/api-keys/'
      path: '/api-keys'
      fullPath: '/api-keys/'
      preLoaderRoute: typeof ApiKeysIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auto-force-outs/': {
      id: '/auto-force-outs/'
      path: '/'
      fullPath: '/auto-force-outs/'
      preLoaderRoute: typeof AutoForceOutsIndexRouteImport
      parentRoute: typeof AutoForceOutsRoute
    }
    '/auto-force-outs/participants': {
      id: '/auto-force-outs/participants'
      path: '/participants'
      fullPath: '/auto-force-outs/participants'
      preLoaderRoute: typeof AutoForceOutsParticipantsRouteImport
      parentRoute: typeof AutoForceOutsRoute
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/messages': {
      id: '/campaigns/messages'
      path: '/messages'
      fullPath: '/campaigns/messages'
      preLoaderRoute: typeof CampaignsMessagesRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/carriers/': {
      id: '/carriers/'
      path: '/carriers'
      fullPath: '/carriers/'
      preLoaderRoute: typeof CarriersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carriers/$annuityIntegrationId': {
      id: '/carriers/$annuityIntegrationId'
      path: '/carriers/$annuityIntegrationId'
      fullPath: '/carriers/$annuityIntegrationId'
      preLoaderRoute: typeof CarriersAnnuityIntegrationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connectivity/': {
      id: '/connectivity/'
      path: '/'
      fullPath: '/connectivity/'
      preLoaderRoute: typeof ConnectivityIndexRouteImport
      parentRoute: typeof ConnectivityRoute
    }
    '/connectivity/map-providers': {
      id: '/connectivity/map-providers'
      path: '/map-providers'
      fullPath: '/connectivity/map-providers'
      preLoaderRoute: typeof ConnectivityMapProvidersRouteImport
      parentRoute: typeof ConnectivityRoute
    }
    '/connectivity/misc': {
      id: '/connectivity/misc'
      path: '/misc'
      fullPath: '/connectivity/misc'
      preLoaderRoute: typeof ConnectivityMiscRouteImport
      parentRoute: typeof ConnectivityRoute
    }
    '/connectivity/sftp': {
      id: '/connectivity/sftp'
      path: '/sftp'
      fullPath: '/connectivity/sftp'
      preLoaderRoute: typeof ConnectivitySftpRouteImport
      parentRoute: typeof ConnectivityRoute
    }
    '/cron-jobs/': {
      id: '/cron-jobs/'
      path: '/cron-jobs'
      fullPath: '/cron-jobs/'
      preLoaderRoute: typeof CronJobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/db-insights/': {
      id: '/db-insights/'
      path: '/'
      fullPath: '/db-insights/'
      preLoaderRoute: typeof DbInsightsIndexRouteImport
      parentRoute: typeof DbInsightsRoute
    }
    '/db-insights/collations': {
      id: '/db-insights/collations'
      path: '/collations'
      fullPath: '/db-insights/collations'
      preLoaderRoute: typeof DbInsightsCollationsRouteImport
      parentRoute: typeof DbInsightsRoute
    }
    '/db-insights/drift': {
      id: '/db-insights/drift'
      path: '/drift'
      fullPath: '/db-insights/drift'
      preLoaderRoute: typeof DbInsightsDriftRouteImport
      parentRoute: typeof DbInsightsRoute
    }
    '/db-insights/slow-queries': {
      id: '/db-insights/slow-queries'
      path: '/slow-queries'
      fullPath: '/db-insights/slow-queries'
      preLoaderRoute: typeof DbInsightsSlowQueriesRouteImport
      parentRoute: typeof DbInsightsRoute
    }
    '/db-insights/tables': {
      id: '/db-insights/tables'
      path: '/tables'
      fullPath: '/db-insights/tables'
      preLoaderRoute: typeof DbInsightsTablesRouteImport
      parentRoute: typeof DbInsightsRoute
    }
    '/flyway/': {
      id: '/flyway/'
      path: '/flyway'
      fullPath: '/flyway/'
      preLoaderRoute: typeof FlywayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/$integrationId': {
      id: '/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/integrations/$integrationId'
      preLoaderRoute: typeof IntegrationsIntegrationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ira-clarity/': {
      id: '/ira-clarity/'
      path: '/ira-clarity'
      fullPath: '/ira-clarity/'
      preLoaderRoute: typeof IraClarityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/managed-account-providers/$managedAccountProviderId': {
      id: '/managed-account-providers/$managedAccountProviderId'
      path: '/managed-account-providers/$managedAccountProviderId'
      fullPath: '/managed-account-providers/$managedAccountProviderId'
      preLoaderRoute: typeof ManagedAccountProvidersManagedAccountProviderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/methodologies/': {
      id: '/methodologies/'
      path: '/methodologies'
      fullPath: '/methodologies/'
      preLoaderRoute: typeof MethodologiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/methodologies/$managedAccountMethodologyId': {
      id: '/methodologies/$managedAccountMethodologyId'
      path: '/methodologies/$managedAccountMethodologyId'
      fullPath: '/methodologies/$managedAccountMethodologyId'
      preLoaderRoute: typeof MethodologiesManagedAccountMethodologyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/$advisoryOrganizationId': {
      id: '/organizations/$advisoryOrganizationId'
      path: '/organizations/$advisoryOrganizationId'
      fullPath: '/organizations/$advisoryOrganizationId'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/participant-transactions/': {
      id: '/participant-transactions/'
      path: '/'
      fullPath: '/participant-transactions/'
      preLoaderRoute: typeof ParticipantTransactionsIndexRouteImport
      parentRoute: typeof ParticipantTransactionsRoute
    }
    '/participant-transactions/exports': {
      id: '/participant-transactions/exports'
      path: '/exports'
      fullPath: '/participant-transactions/exports'
      preLoaderRoute: typeof ParticipantTransactionsExportsRouteImport
      parentRoute: typeof ParticipantTransactionsRoute
    }
    '/participants/': {
      id: '/participants/'
      path: '/participants'
      fullPath: '/participants/'
      preLoaderRoute: typeof ParticipantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/queues/': {
      id: '/queues/'
      path: '/'
      fullPath: '/queues/'
      preLoaderRoute: typeof QueuesIndexRouteImport
      parentRoute: typeof QueuesRoute
    }
    '/queues/$name': {
      id: '/queues/$name'
      path: '/$name'
      fullPath: '/queues/$name'
      preLoaderRoute: typeof QueuesNameRouteImport
      parentRoute: typeof QueuesRoute
    }
    '/queues/settings': {
      id: '/queues/settings'
      path: '/settings'
      fullPath: '/queues/settings'
      preLoaderRoute: typeof QueuesSettingsRouteImport
      parentRoute: typeof QueuesRoute
    }
    '/recordkeepers/': {
      id: '/recordkeepers/'
      path: '/recordkeepers'
      fullPath: '/recordkeepers/'
      preLoaderRoute: typeof RecordkeepersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recordkeepers/$recordKeepingOrganizationId': {
      id: '/recordkeepers/$recordKeepingOrganizationId'
      path: '/recordkeepers/$recordKeepingOrganizationId'
      fullPath: '/recordkeepers/$recordKeepingOrganizationId'
      preLoaderRoute: typeof RecordkeepersRecordKeepingOrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relationship-health/': {
      id: '/relationship-health/'
      path: '/'
      fullPath: '/relationship-health/'
      preLoaderRoute: typeof RelationshipHealthIndexRouteImport
      parentRoute: typeof RelationshipHealthRoute
    }
    '/relationship-health/login': {
      id: '/relationship-health/login'
      path: '/login'
      fullPath: '/relationship-health/login'
      preLoaderRoute: typeof RelationshipHealthLoginRouteImport
      parentRoute: typeof RelationshipHealthRoute
    }
    '/relationship-health/participants': {
      id: '/relationship-health/participants'
      path: '/participants'
      fullPath: '/relationship-health/participants'
      preLoaderRoute: typeof RelationshipHealthParticipantsRouteImport
      parentRoute: typeof RelationshipHealthRoute
    }
    '/relationship-health/plans': {
      id: '/relationship-health/plans'
      path: '/plans'
      fullPath: '/relationship-health/plans'
      preLoaderRoute: typeof RelationshipHealthPlansRouteImport
      parentRoute: typeof RelationshipHealthRoute
    }
    '/s3-browser/': {
      id: '/s3-browser/'
      path: '/s3-browser'
      fullPath: '/s3-browser/'
      preLoaderRoute: typeof S3BrowserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s3-browser/$bucket': {
      id: '/s3-browser/$bucket'
      path: '/s3-browser/$bucket'
      fullPath: '/s3-browser/$bucket'
      preLoaderRoute: typeof S3BrowserBucketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submission-log/': {
      id: '/submission-log/'
      path: '/submission-log'
      fullPath: '/submission-log/'
      preLoaderRoute: typeof SubmissionLogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$loginId': {
      id: '/users/$loginId'
      path: '/users/$loginId'
      fullPath: '/users/$loginId'
      preLoaderRoute: typeof UsersLoginIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/carriers/$annuityIntegrationId/': {
      id: '/carriers/$annuityIntegrationId/'
      path: '/'
      fullPath: '/carriers/$annuityIntegrationId/'
      preLoaderRoute: typeof CarriersAnnuityIntegrationIdIndexRouteImport
      parentRoute: typeof CarriersAnnuityIntegrationIdRoute
    }
    '/carriers/$annuityIntegrationId/api-keys': {
      id: '/carriers/$annuityIntegrationId/api-keys'
      path: '/api-keys'
      fullPath: '/carriers/$annuityIntegrationId/api-keys'
      preLoaderRoute: typeof CarriersAnnuityIntegrationIdApiKeysRouteImport
      parentRoute: typeof CarriersAnnuityIntegrationIdRoute
    }
    '/carriers/$annuityIntegrationId/exports': {
      id: '/carriers/$annuityIntegrationId/exports'
      path: '/exports'
      fullPath: '/carriers/$annuityIntegrationId/exports'
      preLoaderRoute: typeof CarriersAnnuityIntegrationIdExportsRouteImport
      parentRoute: typeof CarriersAnnuityIntegrationIdRoute
    }
    '/carriers/$annuityIntegrationId/transactions': {
      id: '/carriers/$annuityIntegrationId/transactions'
      path: '/transactions'
      fullPath: '/carriers/$annuityIntegrationId/transactions'
      preLoaderRoute: typeof CarriersAnnuityIntegrationIdTransactionsRouteImport
      parentRoute: typeof CarriersAnnuityIntegrationIdRoute
    }
    '/db-insights/tables/': {
      id: '/db-insights/tables/'
      path: '/'
      fullPath: '/db-insights/tables/'
      preLoaderRoute: typeof DbInsightsTablesIndexRouteImport
      parentRoute: typeof DbInsightsTablesRoute
    }
    '/db-insights/tables/$table': {
      id: '/db-insights/tables/$table'
      path: '/$table'
      fullPath: '/db-insights/tables/$table'
      preLoaderRoute: typeof DbInsightsTablesTableRouteImport
      parentRoute: typeof DbInsightsTablesRoute
    }
    '/methodologies/$managedAccountMethodologyId/': {
      id: '/methodologies/$managedAccountMethodologyId/'
      path: '/'
      fullPath: '/methodologies/$managedAccountMethodologyId/'
      preLoaderRoute: typeof MethodologiesManagedAccountMethodologyIdIndexRouteImport
      parentRoute: typeof MethodologiesManagedAccountMethodologyIdRoute
    }
    '/methodologies/$managedAccountMethodologyId/associations': {
      id: '/methodologies/$managedAccountMethodologyId/associations'
      path: '/associations'
      fullPath: '/methodologies/$managedAccountMethodologyId/associations'
      preLoaderRoute: typeof MethodologiesManagedAccountMethodologyIdAssociationsRouteImport
      parentRoute: typeof MethodologiesManagedAccountMethodologyIdRoute
    }
    '/methodologies/$managedAccountMethodologyId/managed-account-providers': {
      id: '/methodologies/$managedAccountMethodologyId/managed-account-providers'
      path: '/managed-account-providers'
      fullPath: '/methodologies/$managedAccountMethodologyId/managed-account-providers'
      preLoaderRoute: typeof MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRouteImport
      parentRoute: typeof MethodologiesManagedAccountMethodologyIdRoute
    }
    '/organizations/$advisoryOrganizationId/': {
      id: '/organizations/$advisoryOrganizationId/'
      path: '/'
      fullPath: '/organizations/$advisoryOrganizationId/'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdIndexRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/activity-monitor': {
      id: '/organizations/$advisoryOrganizationId/activity-monitor'
      path: '/activity-monitor'
      fullPath: '/organizations/$advisoryOrganizationId/activity-monitor'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdActivityMonitorRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/advisors': {
      id: '/organizations/$advisoryOrganizationId/advisors'
      path: '/advisors'
      fullPath: '/organizations/$advisoryOrganizationId/advisors'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdAdvisorsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/edit': {
      id: '/organizations/$advisoryOrganizationId/edit'
      path: '/edit'
      fullPath: '/organizations/$advisoryOrganizationId/edit'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdEditRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/integrations': {
      id: '/organizations/$advisoryOrganizationId/integrations'
      path: '/integrations'
      fullPath: '/organizations/$advisoryOrganizationId/integrations'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdIntegrationsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/licensing': {
      id: '/organizations/$advisoryOrganizationId/licensing'
      path: '/licensing'
      fullPath: '/organizations/$advisoryOrganizationId/licensing'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdLicensingRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/managed-accounts': {
      id: '/organizations/$advisoryOrganizationId/managed-accounts'
      path: '/managed-accounts'
      fullPath: '/organizations/$advisoryOrganizationId/managed-accounts'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdManagedAccountsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/record-keepers': {
      id: '/organizations/$advisoryOrganizationId/record-keepers'
      path: '/record-keepers'
      fullPath: '/organizations/$advisoryOrganizationId/record-keepers'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdRecordKeepersRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/submission-log': {
      id: '/organizations/$advisoryOrganizationId/submission-log'
      path: '/submission-log'
      fullPath: '/organizations/$advisoryOrganizationId/submission-log'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdSubmissionLogRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/white-labels': {
      id: '/organizations/$advisoryOrganizationId/white-labels'
      path: '/white-labels'
      fullPath: '/organizations/$advisoryOrganizationId/white-labels'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdWhiteLabelsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/participants/': {
      id: '/organizations/$advisoryOrganizationId/participants/'
      path: '/participants'
      fullPath: '/organizations/$advisoryOrganizationId/participants/'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdParticipantsIndexRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/': {
      id: '/organizations/$advisoryOrganizationId/plans/'
      path: '/plans'
      fullPath: '/organizations/$advisoryOrganizationId/plans/'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansIndexRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId'
      path: '/plans/$planId'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/'
      path: '/'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/advisors': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/advisors'
      path: '/advisors'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/advisors'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs'
      path: '/core-calcs'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash'
      path: '/equity-wash'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/equity-wash'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/funds': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/funds'
      path: '/funds'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/funds'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program'
      path: '/managed-account-program'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/managed-account-program'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/participants': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/participants'
      path: '/participants'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/participants'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId/settings': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId/settings'
      path: '/settings'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/settings'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute
    }
    '/organizations/$advisoryOrganizationId/plans/$planId_/participants/$planEnrollmentId': {
      id: '/organizations/$advisoryOrganizationId/plans/$planId_/participants/$planEnrollmentId'
      path: '/plans/$planId/participants/$planEnrollmentId'
      fullPath: '/organizations/$advisoryOrganizationId/plans/$planId/participants/$planEnrollmentId'
      preLoaderRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRouteImport
      parentRoute: typeof OrganizationsAdvisoryOrganizationIdRoute
    }
  }
}

interface AutoForceOutsRouteChildren {
  AutoForceOutsParticipantsRoute: typeof AutoForceOutsParticipantsRoute
  AutoForceOutsIndexRoute: typeof AutoForceOutsIndexRoute
}

const AutoForceOutsRouteChildren: AutoForceOutsRouteChildren = {
  AutoForceOutsParticipantsRoute: AutoForceOutsParticipantsRoute,
  AutoForceOutsIndexRoute: AutoForceOutsIndexRoute,
}

const AutoForceOutsRouteWithChildren = AutoForceOutsRoute._addFileChildren(
  AutoForceOutsRouteChildren,
)

interface CampaignsRouteChildren {
  CampaignsMessagesRoute: typeof CampaignsMessagesRoute
  CampaignsIndexRoute: typeof CampaignsIndexRoute
}

const CampaignsRouteChildren: CampaignsRouteChildren = {
  CampaignsMessagesRoute: CampaignsMessagesRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
}

const CampaignsRouteWithChildren = CampaignsRoute._addFileChildren(
  CampaignsRouteChildren,
)

interface ConnectivityRouteChildren {
  ConnectivityMapProvidersRoute: typeof ConnectivityMapProvidersRoute
  ConnectivityMiscRoute: typeof ConnectivityMiscRoute
  ConnectivitySftpRoute: typeof ConnectivitySftpRoute
  ConnectivityIndexRoute: typeof ConnectivityIndexRoute
}

const ConnectivityRouteChildren: ConnectivityRouteChildren = {
  ConnectivityMapProvidersRoute: ConnectivityMapProvidersRoute,
  ConnectivityMiscRoute: ConnectivityMiscRoute,
  ConnectivitySftpRoute: ConnectivitySftpRoute,
  ConnectivityIndexRoute: ConnectivityIndexRoute,
}

const ConnectivityRouteWithChildren = ConnectivityRoute._addFileChildren(
  ConnectivityRouteChildren,
)

interface DbInsightsTablesRouteChildren {
  DbInsightsTablesTableRoute: typeof DbInsightsTablesTableRoute
  DbInsightsTablesIndexRoute: typeof DbInsightsTablesIndexRoute
}

const DbInsightsTablesRouteChildren: DbInsightsTablesRouteChildren = {
  DbInsightsTablesTableRoute: DbInsightsTablesTableRoute,
  DbInsightsTablesIndexRoute: DbInsightsTablesIndexRoute,
}

const DbInsightsTablesRouteWithChildren =
  DbInsightsTablesRoute._addFileChildren(DbInsightsTablesRouteChildren)

interface DbInsightsRouteChildren {
  DbInsightsCollationsRoute: typeof DbInsightsCollationsRoute
  DbInsightsDriftRoute: typeof DbInsightsDriftRoute
  DbInsightsSlowQueriesRoute: typeof DbInsightsSlowQueriesRoute
  DbInsightsTablesRoute: typeof DbInsightsTablesRouteWithChildren
  DbInsightsIndexRoute: typeof DbInsightsIndexRoute
}

const DbInsightsRouteChildren: DbInsightsRouteChildren = {
  DbInsightsCollationsRoute: DbInsightsCollationsRoute,
  DbInsightsDriftRoute: DbInsightsDriftRoute,
  DbInsightsSlowQueriesRoute: DbInsightsSlowQueriesRoute,
  DbInsightsTablesRoute: DbInsightsTablesRouteWithChildren,
  DbInsightsIndexRoute: DbInsightsIndexRoute,
}

const DbInsightsRouteWithChildren = DbInsightsRoute._addFileChildren(
  DbInsightsRouteChildren,
)

interface ParticipantTransactionsRouteChildren {
  ParticipantTransactionsExportsRoute: typeof ParticipantTransactionsExportsRoute
  ParticipantTransactionsIndexRoute: typeof ParticipantTransactionsIndexRoute
}

const ParticipantTransactionsRouteChildren: ParticipantTransactionsRouteChildren =
  {
    ParticipantTransactionsExportsRoute: ParticipantTransactionsExportsRoute,
    ParticipantTransactionsIndexRoute: ParticipantTransactionsIndexRoute,
  }

const ParticipantTransactionsRouteWithChildren =
  ParticipantTransactionsRoute._addFileChildren(
    ParticipantTransactionsRouteChildren,
  )

interface QueuesRouteChildren {
  QueuesNameRoute: typeof QueuesNameRoute
  QueuesSettingsRoute: typeof QueuesSettingsRoute
  QueuesIndexRoute: typeof QueuesIndexRoute
}

const QueuesRouteChildren: QueuesRouteChildren = {
  QueuesNameRoute: QueuesNameRoute,
  QueuesSettingsRoute: QueuesSettingsRoute,
  QueuesIndexRoute: QueuesIndexRoute,
}

const QueuesRouteWithChildren =
  QueuesRoute._addFileChildren(QueuesRouteChildren)

interface RelationshipHealthRouteChildren {
  RelationshipHealthLoginRoute: typeof RelationshipHealthLoginRoute
  RelationshipHealthParticipantsRoute: typeof RelationshipHealthParticipantsRoute
  RelationshipHealthPlansRoute: typeof RelationshipHealthPlansRoute
  RelationshipHealthIndexRoute: typeof RelationshipHealthIndexRoute
}

const RelationshipHealthRouteChildren: RelationshipHealthRouteChildren = {
  RelationshipHealthLoginRoute: RelationshipHealthLoginRoute,
  RelationshipHealthParticipantsRoute: RelationshipHealthParticipantsRoute,
  RelationshipHealthPlansRoute: RelationshipHealthPlansRoute,
  RelationshipHealthIndexRoute: RelationshipHealthIndexRoute,
}

const RelationshipHealthRouteWithChildren =
  RelationshipHealthRoute._addFileChildren(RelationshipHealthRouteChildren)

interface CarriersAnnuityIntegrationIdRouteChildren {
  CarriersAnnuityIntegrationIdApiKeysRoute: typeof CarriersAnnuityIntegrationIdApiKeysRoute
  CarriersAnnuityIntegrationIdExportsRoute: typeof CarriersAnnuityIntegrationIdExportsRoute
  CarriersAnnuityIntegrationIdTransactionsRoute: typeof CarriersAnnuityIntegrationIdTransactionsRoute
  CarriersAnnuityIntegrationIdIndexRoute: typeof CarriersAnnuityIntegrationIdIndexRoute
}

const CarriersAnnuityIntegrationIdRouteChildren: CarriersAnnuityIntegrationIdRouteChildren =
  {
    CarriersAnnuityIntegrationIdApiKeysRoute:
      CarriersAnnuityIntegrationIdApiKeysRoute,
    CarriersAnnuityIntegrationIdExportsRoute:
      CarriersAnnuityIntegrationIdExportsRoute,
    CarriersAnnuityIntegrationIdTransactionsRoute:
      CarriersAnnuityIntegrationIdTransactionsRoute,
    CarriersAnnuityIntegrationIdIndexRoute:
      CarriersAnnuityIntegrationIdIndexRoute,
  }

const CarriersAnnuityIntegrationIdRouteWithChildren =
  CarriersAnnuityIntegrationIdRoute._addFileChildren(
    CarriersAnnuityIntegrationIdRouteChildren,
  )

interface MethodologiesManagedAccountMethodologyIdRouteChildren {
  MethodologiesManagedAccountMethodologyIdAssociationsRoute: typeof MethodologiesManagedAccountMethodologyIdAssociationsRoute
  MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute: typeof MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute
  MethodologiesManagedAccountMethodologyIdIndexRoute: typeof MethodologiesManagedAccountMethodologyIdIndexRoute
}

const MethodologiesManagedAccountMethodologyIdRouteChildren: MethodologiesManagedAccountMethodologyIdRouteChildren =
  {
    MethodologiesManagedAccountMethodologyIdAssociationsRoute:
      MethodologiesManagedAccountMethodologyIdAssociationsRoute,
    MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute:
      MethodologiesManagedAccountMethodologyIdManagedAccountProvidersRoute,
    MethodologiesManagedAccountMethodologyIdIndexRoute:
      MethodologiesManagedAccountMethodologyIdIndexRoute,
  }

const MethodologiesManagedAccountMethodologyIdRouteWithChildren =
  MethodologiesManagedAccountMethodologyIdRoute._addFileChildren(
    MethodologiesManagedAccountMethodologyIdRouteChildren,
  )

interface OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteChildren {
  OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute
}

const OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteChildren: OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteChildren =
  {
    OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdAdvisorsRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdCoreCalcsRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdEquityWashRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdFundsRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdManagedAccountProgramRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdSettingsRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdIndexRoute,
  }

const OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteWithChildren =
  OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute._addFileChildren(
    OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteChildren,
  )

interface OrganizationsAdvisoryOrganizationIdRouteChildren {
  OrganizationsAdvisoryOrganizationIdActivityMonitorRoute: typeof OrganizationsAdvisoryOrganizationIdActivityMonitorRoute
  OrganizationsAdvisoryOrganizationIdAdvisorsRoute: typeof OrganizationsAdvisoryOrganizationIdAdvisorsRoute
  OrganizationsAdvisoryOrganizationIdEditRoute: typeof OrganizationsAdvisoryOrganizationIdEditRoute
  OrganizationsAdvisoryOrganizationIdIntegrationsRoute: typeof OrganizationsAdvisoryOrganizationIdIntegrationsRoute
  OrganizationsAdvisoryOrganizationIdLicensingRoute: typeof OrganizationsAdvisoryOrganizationIdLicensingRoute
  OrganizationsAdvisoryOrganizationIdManagedAccountsRoute: typeof OrganizationsAdvisoryOrganizationIdManagedAccountsRoute
  OrganizationsAdvisoryOrganizationIdRecordKeepersRoute: typeof OrganizationsAdvisoryOrganizationIdRecordKeepersRoute
  OrganizationsAdvisoryOrganizationIdSubmissionLogRoute: typeof OrganizationsAdvisoryOrganizationIdSubmissionLogRoute
  OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute: typeof OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute
  OrganizationsAdvisoryOrganizationIdIndexRoute: typeof OrganizationsAdvisoryOrganizationIdIndexRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteWithChildren
  OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute: typeof OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute
  OrganizationsAdvisoryOrganizationIdPlansIndexRoute: typeof OrganizationsAdvisoryOrganizationIdPlansIndexRoute
  OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute: typeof OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute
}

const OrganizationsAdvisoryOrganizationIdRouteChildren: OrganizationsAdvisoryOrganizationIdRouteChildren =
  {
    OrganizationsAdvisoryOrganizationIdActivityMonitorRoute:
      OrganizationsAdvisoryOrganizationIdActivityMonitorRoute,
    OrganizationsAdvisoryOrganizationIdAdvisorsRoute:
      OrganizationsAdvisoryOrganizationIdAdvisorsRoute,
    OrganizationsAdvisoryOrganizationIdEditRoute:
      OrganizationsAdvisoryOrganizationIdEditRoute,
    OrganizationsAdvisoryOrganizationIdIntegrationsRoute:
      OrganizationsAdvisoryOrganizationIdIntegrationsRoute,
    OrganizationsAdvisoryOrganizationIdLicensingRoute:
      OrganizationsAdvisoryOrganizationIdLicensingRoute,
    OrganizationsAdvisoryOrganizationIdManagedAccountsRoute:
      OrganizationsAdvisoryOrganizationIdManagedAccountsRoute,
    OrganizationsAdvisoryOrganizationIdRecordKeepersRoute:
      OrganizationsAdvisoryOrganizationIdRecordKeepersRoute,
    OrganizationsAdvisoryOrganizationIdSubmissionLogRoute:
      OrganizationsAdvisoryOrganizationIdSubmissionLogRoute,
    OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute:
      OrganizationsAdvisoryOrganizationIdWhiteLabelsRoute,
    OrganizationsAdvisoryOrganizationIdIndexRoute:
      OrganizationsAdvisoryOrganizationIdIndexRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdRouteWithChildren,
    OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute:
      OrganizationsAdvisoryOrganizationIdParticipantsIndexRoute,
    OrganizationsAdvisoryOrganizationIdPlansIndexRoute:
      OrganizationsAdvisoryOrganizationIdPlansIndexRoute,
    OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute:
      OrganizationsAdvisoryOrganizationIdPlansPlanIdParticipantsPlanEnrollmentIdRoute,
  }

const OrganizationsAdvisoryOrganizationIdRouteWithChildren =
  OrganizationsAdvisoryOrganizationIdRoute._addFileChildren(
    OrganizationsAdvisoryOrganizationIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnnuityAccountErrorsRoute: AnnuityAccountErrorsRoute,
  AutoForceOutsRoute: AutoForceOutsRouteWithChildren,
  CampaignsRoute: CampaignsRouteWithChildren,
  ConnectivityRoute: ConnectivityRouteWithChildren,
  DbInsightsRoute: DbInsightsRouteWithChildren,
  LoginRoute: LoginRoute,
  ParticipantTransactionsRoute: ParticipantTransactionsRouteWithChildren,
  QueuesRoute: QueuesRouteWithChildren,
  RelationshipHealthRoute: RelationshipHealthRouteWithChildren,
  SetupRoute: SetupRoute,
  SsoErrorsRoute: SsoErrorsRoute,
  CarriersAnnuityIntegrationIdRoute:
    CarriersAnnuityIntegrationIdRouteWithChildren,
  IntegrationsIntegrationIdRoute: IntegrationsIntegrationIdRoute,
  ManagedAccountProvidersManagedAccountProviderIdRoute:
    ManagedAccountProvidersManagedAccountProviderIdRoute,
  MethodologiesManagedAccountMethodologyIdRoute:
    MethodologiesManagedAccountMethodologyIdRouteWithChildren,
  OrganizationsAdvisoryOrganizationIdRoute:
    OrganizationsAdvisoryOrganizationIdRouteWithChildren,
  RecordkeepersRecordKeepingOrganizationIdRoute:
    RecordkeepersRecordKeepingOrganizationIdRoute,
  S3BrowserBucketRoute: S3BrowserBucketRoute,
  UsersLoginIdRoute: UsersLoginIdRoute,
  ActivityMonitorIndexRoute: ActivityMonitorIndexRoute,
  ApiKeysIndexRoute: ApiKeysIndexRoute,
  CarriersIndexRoute: CarriersIndexRoute,
  CronJobsIndexRoute: CronJobsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  FlywayIndexRoute: FlywayIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  IraClarityIndexRoute: IraClarityIndexRoute,
  MethodologiesIndexRoute: MethodologiesIndexRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
  ParticipantsIndexRoute: ParticipantsIndexRoute,
  RecordkeepersIndexRoute: RecordkeepersIndexRoute,
  S3BrowserIndexRoute: S3BrowserIndexRoute,
  SubmissionLogIndexRoute: SubmissionLogIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
